export default () => new Promise((resolve) => {
  if (['complete', 'loaded', 'interactive'].indexOf(document.readyState) !== -1) {
    resolve();
  } else {
    window.addEventListener('DOMContentLoaded', resolve, false);
  }
});
